import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DatiqMenuModule } from '@dat/datiq-components-pkg/menu';

import { DatiqLoaderModule } from '@dat/datiq-components-pkg/loader';
import { DatiqScreenModule } from '@dat/datiq-components-pkg/screen';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';
import { DatiqPanelComponent, DatiqPanelMiniComponent } from './components';
import { DatiqTooltipModule } from '@dat/datiq-components-pkg/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatiqUtilsDirectiveModule } from '@dat/datiq-components-pkg/utils';

const components = [DatiqPanelComponent, DatiqPanelMiniComponent];

@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatSelectModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        ReactiveFormsModule,
        DatiqTooltipModule,
        DatiqMenuModule,
        MatExpansionModule,
        MatTooltipModule,
        DatiqUtilsDirectiveModule,
        MatProgressBarModule,
        DatiqLoaderModule,
        DatiqScreenModule,
        DatiqTemplateModule,
    ],
})
export class DatiqPanelModule {}
